import type { ComponentType, FC } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ListItemButton } from "@mui/material";
import type { SvgIconProps } from "@mui/material";
import {
  MenuIcon,
  StyledListItemButton,
  StyledListItemIcon,
  StyledListItemText,
} from "../atoms/Menu";

const RouterStyledListItemButton =
  StyledListItemButton as typeof ListItemButton;

interface IMenuItem {
  path?: string;
  label: string;
  onClick?: () => void;
  iconClass?: string;
  disabled?: boolean;
  Icon?: ComponentType<SvgIconProps>;
}

const MenuItem: FC<IMenuItem> = ({
  path,
  label,
  onClick,
  iconClass,
  Icon,
  disabled = false,
}) => {
  const location = useLocation();
  return path ? (
    <RouterStyledListItemButton
      selected={location.pathname.includes(path)}
      component={NavLink}
      to={path}
      disabled={disabled}
      onClick={() => onClick && onClick()}
    >
      <StyledListItemIcon>
        <MenuIcon>{Icon && <Icon />}</MenuIcon>
      </StyledListItemIcon>
      <StyledListItemText primary={label} />
    </RouterStyledListItemButton>
  ) : (
    <StyledListItemButton
      disabled={disabled}
      onClick={() => onClick && onClick()}
    >
      <StyledListItemIcon>
        <MenuIcon className={iconClass} />
      </StyledListItemIcon>
      <StyledListItemText primary={label} />
    </StyledListItemButton>
  );
};

export { MenuItem };
